import { render, staticRenderFns } from "./ASnackbar.vue?vue&type=template&id=a347cf0e"
import script from "./ASnackbar.vue?vue&type=script&lang=ts"
export * from "./ASnackbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports